// utils/tenantConfig.ts
export function getTenantConfig(origin?: string) {
  const domain = origin?.replace(/^https?:\/\//, "").split("/")[0] || "";

  switch (true) {
    case domain.includes("metricoidtech.com"):
      return {
        title: "Metricoid",
        favicon: "/metricoid/favicon.png",
        logo: "/metricoid/logo.png",
        smtp: { from: "hello@metricoidtech.com" },
      };
    case domain.includes("getmscribe.com"):
      return {
        title: "MScribe",
        favicon: "/mscribe/logo.svg",
        logo: "/mscribe/logo.svg",
        smtp: { from: "do-not-reply@mtesthub.com" },
      };
    case domain.includes("getmtrackpro.com"):
      return {
        title: "MTrackPro",
        favicon: "/favicon.png",
        logo: "/mTestHub.svg",
        smtp: { from: "do-not-reply@mtesthub.com" },
      };
    case domain.includes("localhost:3000"):
      return {
        title: "localhost Tech",
        favicon: "/metricoid/favicon.png",
        logo: "/metricoid/logo.svg",
        smtp: { from: "do-not-reply@mtesthub.com" },
      };
    default:
      return {
        title: "MTestHub",
        favicon: "/favicon.png",
        logo: "/mTestHub.png",
        smtp: { from: "do-not-reply@mtesthub.com" },
      };
  }
}
